
























import icoLookup from '@/utilities/ico-lookup'
import { upload } from '@/utilities/asset-helpers'
import { Component, Prop, Vue } from 'vue-property-decorator'
import * as db from '@shared/types/database'
import { Button } from '@alpha/ink'

@Component({
  components: {
    Button
  }
})
export default class FilePicker extends Vue {
  @Prop({ default: false }) disabled!: boolean

  fallback = false
  uploading = false

  get icoLookup () {
    return icoLookup
  }

  get buttonText () {
    if (this.uploading) return 'Uploading File'
    return 'Browse Computer'
  }

  mounted () {
    this.fallback = true
  }

  addAssetUrl () {
    if (this.uploading) return false
    const assetTemplate: db.Prototype = {
      asset_type: 'url',
      title: '',
      url: ''
    }

    const timestamp = +new Date()
    const newUrlAsset: Record<string, db.Prototype> = {}
    newUrlAsset[timestamp] = assetTemplate
    this.$emit('fileChange', newUrlAsset)
  }

  addAsset (event: Event) {
    event.preventDefault();
    (this.$refs.fallbackUpload as HTMLInputElement).click()
  }

  handleFallbackUpload (event: Event) {
    const files = (event.target as HTMLInputElement).files
    if (!files) {
      throw new Error('Missing files from upload')
    }
    this.uploading = true
    const timestamp = +new Date()
    const newAssets: Record<string, db.Prototype> = {}
    let toUpload = files.length
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const ts = timestamp + i
      this.uploadFallback(file, (asset: db.Prototype) => {
        toUpload--
        // add asset to newAssets, emulate the object format that filePicker uses, so we can reuse code
        newAssets[ts] = asset
        if (toUpload === 0) {
          this.uploading = false
          this.$emit('fileChange', newAssets)
          const uploader = this.$refs.fallbackUpload as HTMLInputElement
          uploader.value = ''
        }
      })
    }
  }

  async uploadFallback (file: File, cb: (asset: db.Prototype) => void) {
    const asset = await upload(file) as db.Prototype
    cb(asset)
  }
}
